<template>
  <div class="default-vue">
    <div class="flex-row justify-content-center dektop-display">
      <div v-if="result && result.length" class="inner-content-wrapper col-md-12">
         <div  v-for="(aType, index) in result.slice(0, 2)" :value="aType" :key="index">
          <div class="flex-row chart-item-row" v-if="aType.topic && aType.color && aType.numberOfParticipants">
              <span class="align-self-center text-right topic col-md-12">{{ aType.topic }}</span>
              <div class="vertical-line align-self-center" :style="{ 'border-left': '7px solid ' + aType.color }"></div>
              <span class="text-left align-self-center number-of-participants col-lg-5 col-md-7">{{ aType.numberOfParticipants }} <span class="perchetage">%</span></span>
          </div> 
         </div>
      </div>
      <div class="chart-container col-md-4 col-lg-4 p-0">
        <canvas id="myChart" role="img" aria-label="Participated in the Past"></canvas>
        <div v-if="chartCustomText" class="chart-text">{{ chartCustomText }}</div>
      </div>
      <div v-if="result && result.length" class="inner-content-wrapper col-md-12">
         <div  v-for="(aType, index) in result.slice(2, 4)" :value="aType" :key="index" class="flip">
          <div class="flex-row chart-item-row" v-if="aType.topic && aType.color && aType.numberOfParticipants">
              <span class="align-self-center topic col-md-12">{{ aType.topic }}</span>
              <div class="vertical-line align-self-center" :style="{ 'border-left': '7px solid ' + aType.color }"></div>
              <span class="text-right align-self-center number-of-participants col-lg-5 col-md-7">{{ aType.numberOfParticipants }} <span class="perchetage">%</span></span>
            </div> 
         </div>
      </div>
    </div>
    <div class="mobile-display">
    <div v-if="result && result.length" class="flex-row justify-content-center flex-column" style="align-items:center;">
      <div v-for="(aType, index) in result.slice(0,4)" :value="aType" :key="index" :class="{ 'flip': index === 0 || index === 2 }">
        <div class="flex-row mb-5" v-if="aType.topic && aType.color && aType.numberOfParticipants">
          <span :class="{ 'text-left': index === 0 || index === 2 , 'text-right': index === 1 || index === 3}" class="align-self-center topic col-sm-6 col-xs-6">{{ aType.topic }}</span>
          <div class="vertical-line align-self-center" :style="{ 'border-left': '7px solid ' + aType.color }"></div>
          <span :class="{ 'text-right': index === 0 || index === 2 }" class="align-self-center number-of-participants col-sm-6 col-xs-6">{{ aType.numberOfParticipants }} <span class="perchetage">%</span></span>
        </div> 
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'vueChartDisplay',
  props: {
     settingsPerm: Object
  },
   data() {
     return {
            result:null,
            loading:false, 
            error:true,
            data: this.settingsPerm,
            chartRandomId: null,
            labels:[],
            realdata: [],
            colorCodes: [],
            chartCustomText: this.settingsPerm.chartcustomtext
        }
    },
  mounted() {
    this.setMaxHeightForEachIteam();
    if (this.realdata && this.realdata.length && this.labels && this.labels.length) { 
      this.createChart(); 
    }
  },
  created() {
    let data =  JSON.parse(this.data.participateSectionRepeater);
    this.result = data;
    if (this.result && this.result.length) {
      this.labels = [];
      this.realdata = [];
      this.result.forEach((item) => {
        if (item) {
          if (item.topic) {
            this.labels.push(item.topic);
          }
          if (item.numberOfParticipants) {
            this.realdata.push(item.numberOfParticipants);
          }
          if (item.color) {
            this.colorCodes.push(item.color);
          }
        }
      });
    } 
  },
  methods: {
    createChart(){
      this.chartRandomId = 'MyChart' + Math.random().toString(36).substring(7);
      const ctx = document.getElementById('myChart');

      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [{
            data: this.realdata,
            backgroundColor: this.colorCodes,
            borderWidth: 1
          }]
        },
        options: {
          cutout: 120,
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            }
          },
        }
      });
    },  
    // find the biggest height of each flex-row and apply it to all
    setMaxHeightForEachIteam() {
      const rows = document.querySelectorAll('.chart-item-row');
      if (rows && rows.length) {
        let maxHeight = 0;
        rows.forEach(row => {
          const height = row.clientHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
        rows.forEach(row => {
          row.style.height = `${maxHeight}px`;
        });
      }
    }
  },
}
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .chart-container {
    position: relative;
      height: auto;
      max-height: 300px;
  }
  .vertical-line {
    height: 4em;
    border-radius: 20px;
  }
 .item-width{
    width: 140px;
  }
  .topic{
    font-size: clamp(1.435rem, 2vw, 2.875rem);
    word-wrap: break-word;
  }
  .number-of-participants{
    font-size: clamp(2.87rem, 3vw, 5.75rem);
    font-weight: 700;
  }
  .perchetage{
    font-size: clamp(2.125rem, 1.125vw, 1.125rem);
  }
  @media (min-width: 992px) {
    .mobile-display{
      display: none;
    }
  }
  @media (max-width: 992px) {
    .dektop-display{
      display: none;
    }
  }
  @media (max-width: 768px) {
    .item-width{
      width: 100px;
    }

  }
  .flip .topic{
    order:2;
  }
  .flip .vertical-line{
    order:1;
  }
  .inner-content-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  
  .chart-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    color: #000;
    text-align: center;
    font-size: clamp(2.8125rem, 1vw, 3.75rem);
    font-weight: 600;
  }
</style>
